import React from 'react';
import styled, { css } from 'styled-components';
import { BrowserView, MobileView } from 'react-device-detect';

import { media } from '@/utils/mixin';

import CarsStockDesktop from './components/Desktop';
import CarsStockMobile from './components/Mobile';
import { CarsStockProps } from './types';

function CarsStock({ carsType }: CarsStockProps) {
  return (
    <Component>
      <ContentContainer>
        <BrowserView>
          <CarsStockDesktop carsType={carsType} />
        </BrowserView>

        <MobileView>
          <CarsStockMobile carsType={carsType} />
        </MobileView>
      </ContentContainer>
    </Component>
  );
}

export default CarsStock;

const Component = styled.section`
  position: relative;
  padding: 25px 0 50px;
  background: ${(props) => props.theme.white};

  ${media.tablet(css`
    padding: 25px 0;
  `)}
`;

const ContentContainer = styled.div`
  max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  padding: 0 40px;

  ${media.tablet(css`
    padding: 0 20px;
  `)}
`;
